import React, { useEffect, useRef } from "react";

import { Route, useHistory, useLocation } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { AuthProvider } from "../../contexts/auth";
import { CurrencyProvider } from "../../contexts/currency";
import { PageProvider } from "../../contexts/page";
import { ProfileProvider } from "../../contexts/profile";
import { SeedProvider } from "../../contexts/seed";
import { ToastProvider } from "../../contexts/toast";
import { AuthProvider as ZoAuthProvider } from "../../contexts/zoauth";
import { gtag, updateTrackingInfo } from "../../utils/track";
import Routes from "./components/Routes";
// import FooterNav from "./components/FooterNav";

interface WebsiteProps {}

const Website: React.FC<WebsiteProps> = () => {
  const location = useLocation();
  const history = useHistory();

  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    updateTrackingInfo(location.search);
  }, [location.search]);

  useEffect(() => {
    const sendPageView = (path: string) => {
      console.log(path, "path");

      gtag("event", "page_view", {
        page_path: path,
      });
    };

    // Send pageview on initial load
    sendPageView(window.location.pathname);

    // Send pageview on route changes
    const unlisten = history.listen((location) => {
      sendPageView(location.pathname);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <ToastProvider>
      <ZoAuthProvider>
        <AuthProvider name="website">
          <QueryParamProvider ReactRouterRoute={Route}>
            <ProfileProvider>
              <SeedProvider name="website">
                <CurrencyProvider>
                  <PageProvider>
                    <main
                      className="w-screen min-h-screen bg-white max-w-full text-dark theme-website"
                      ref={ref}
                    >
                      <Routes />
                    </main>
                  </PageProvider>
                </CurrencyProvider>
              </SeedProvider>
            </ProfileProvider>
          </QueryParamProvider>
        </AuthProvider>
      </ZoAuthProvider>
    </ToastProvider>
  );
};

export default Website;
